import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FAVICON_ICONS } from '../../constants';
import { APP_VARIABLES_TOKEN, AppVariables } from '../../../../../frontend-variables/src/lib';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  constructor(
    @Inject(DOCUMENT) private readonly document: HTMLDocument,
    @Inject(APP_VARIABLES_TOKEN) private readonly appVariables: AppVariables,
  ) {
  }

  generate() {
    const head = this.document.getElementsByTagName('head')[0];
    const fragment = this.document.createDocumentFragment();
    const links = [...FAVICON_ICONS];

    links.forEach((link) => {
      const tag = this.document.createElement("link");
      tag.setAttribute('rel', link.rel);
      tag.setAttribute('href', `./assets/img/${this.appVariables.WHITELABEL_BRAND.toLowerCase()}/${link.name}`);
      tag.setAttribute('sizes', link.sizes);
      tag.setAttribute('media', link.media);
      tag.setAttribute('color', link.color);
      fragment.appendChild(tag);
    });

    head.appendChild(fragment);
  }
}
